import { createContext } from "react";
import { useState } from "react";

const ExpertProfessionsContext = createContext({
  comprehensiveProfessionsIds: null,
  farmingIds: null,
  greenHouseIds: null,
  liveStockIds: null,
  veterinaryIds: null
});

export const ExpertProfessionsProvider = ({ children }) => {
  const [comprehensiveProfessionsIds, setComprehensiveProfessionsIds] = useState(null);
  const [farmingIds, setFarmingIds] = useState(null);
  const [greenHouseIds, setGreenHouseIds] = useState(null);
  const [liveStockIds, setLiveStockIds] = useState(null);
  const [veterinaryIds, setVeterinaryIds] = useState(null);

  const comprehensiveProfessionsIdsAction = (data) => {
    setComprehensiveProfessionsIds(data)
  };
  const farmingIdsAction = (data) => {
    setFarmingIds(data)
  };
  const greenHouseIdsAction = (data) => {
    setGreenHouseIds(data)
  };
  const liveStockIdsAction = (data) => {
    setLiveStockIds(data)
  };
  const veterinaryIdsAction = (data) => {
    setVeterinaryIds(data)
  };
  const resetProfessions = () => {
    setComprehensiveProfessionsIds(null)
    setFarmingIds(null)
    setGreenHouseIds(null)
    setLiveStockIds(null)
    setVeterinaryIds(null)
  }

  return (
    <ExpertProfessionsContext.Provider
      value={{
        comprehensiveProfessionsIds,
        farmingIds,
        greenHouseIds,
        liveStockIds,
        veterinaryIds,
        comprehensiveProfessionsIdsAction,
        farmingIdsAction,
        greenHouseIdsAction,
        liveStockIdsAction,
        veterinaryIdsAction,
        resetProfessions
      }}
    >
      {children}
    </ExpertProfessionsContext.Provider>
  );
};

export default ExpertProfessionsContext;
